import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import PolicyRateProfilesHelpModal from "./Help";
import PolicyRateProfileSettingsHelpModal from "./SettingsHelp";
import { composedAPI } from "./api";
import policyRateComposition from "./composition";

const ConfigPolicyRateProfiles = ({ ...settings }) => (
  <>
    <ProfilesAndSettings
      {...policyRateComposition}
      {...composedAPI}
      {...settings}
    />
    <PolicyRateProfilesHelpModal />
    <PolicyRateProfileSettingsHelpModal />
  </>
);

export default ConfigPolicyRateProfiles;
